import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../StyleSheet/AppComponent/SideBar/SideBar.scss";
import logo from "../../../Assets/AppComponent/Logo/Group 56.png";
import profile from "../../../Assets/AppComponent/Profile/profile.png";
import {
  getsidebarActions,
  getSideBarfilesActions,
  getSideBarStatus,
  SetTHeNavigateList,
  setaRoleChnage,
  SetDashboards,
  setTheTODATELISTINDASH,
  setDropDownRenders,
  setTheFROMDATELIST,
  setTheRoleRemoveFilters,
  getSingleEmployeeActions,
  setTheApproveRequeststate,
  settheTicketraiseroutes,
  gettheSideBarNotificationState,
  settheInternal_Statuss,
  settheTicketingSUbOptionValuesListed,
  setTheTicketingsystemStatusState,
  setTheTicketingsystemtRange1,
  setTheTicketingsystemRange2,
  gettheinternalUsersTicketingRangesone,
  gettheinternalUsersTicketingRangesTwo,
} from "../../../Redux/Slice";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import PersonIcon from "@mui/icons-material/Person";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CabinIcon from "@mui/icons-material/Cabin";
import SouthAmericaIcon from "@mui/icons-material/SouthAmerica";
import AddHomeIcon from "@mui/icons-material/AddHome";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AirlineStopsIcon from "@mui/icons-material/AirlineStops";
import FilterTiltShiftIcon from "@mui/icons-material/FilterTiltShift";
import { useNavigate } from "react-router-dom";
import AttributionIcon from "@mui/icons-material/Attribution";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import { NavLink } from "react-router-dom";
import PlaceIcon from "@mui/icons-material/Place";
import BadgeIcon from "@mui/icons-material/Badge";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import $ from "jquery";
import ExitToAppSharpIcon from "@mui/icons-material/ExitToAppSharp";
import EnergySavingsLeafIcon from "@mui/icons-material/EnergySavingsLeaf";
import GroupIcon from "@mui/icons-material/Group";
import PaidIcon from "@mui/icons-material/Paid";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import FollowTheSignsIcon from "@mui/icons-material/FollowTheSigns";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import PaymentIcon from "@mui/icons-material/Payment";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import NfcIcon from "@mui/icons-material/Nfc";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import Man2Icon from "@mui/icons-material/Man2";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import BlockIcon from "@mui/icons-material/Block";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import imageone from "../../../Assets/AppComponent/sidebar/UDS NAVBAR ICONS-01.png";
import MotionPhotosAutoIcon from "@mui/icons-material/MotionPhotosAuto";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import TimelapseIcon from "@material-ui/icons/Timelapse";
import PieChartIcon from "@material-ui/icons/PieChart";
import ReportIcon from "@mui/icons-material/Report";

///-------sidebar--------images---
import DashboardWhiteIma from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-34.svg";
import Dashboardoverview from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-35.svg";
import Dashboardattendance from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-36.svg";
import DashboardonboardOverview from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-37.svg";

import validations from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-38.svg";
import aadharvalidation from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-39.svg";
import panvalidation from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-40.svg";
import whatsappvalidation from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-41.svg";

import bankcardValidations from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-42.svg";
import clientImage from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-43.svg";
import designationimage from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-44.svg";
import userImages from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-44.svg";

import onboardimage from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-45.svg";
import appriverequstimage from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-46.svg";
import onboardingemployees from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-47.svg";
import attendancefeild from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-48.svg";

import attendanceReport from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-45.svg";
import LeaveTypeimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-46.svg";
import LeaveRequest from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-47.svg";
import premissionrequestImg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-48.svg";

import ondutyImg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-46.svg";
import attendanceregularzationImg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-47.svg";
import skillAssesment from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-48.svg";
import criteria from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-49.svg";

import assementsImg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-50.svg";
import exitflow from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-51.svg";
import noduefomrimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-52.svg";
import resignimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-53.svg";

import employeementimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-54.svg";
import reimbursementimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-55.svg";
import blockimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-56.svg";
import sitetransfer from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-57.svg";

import activeDeactive from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-58.svg";

import appraisalimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-59.svg";
import payslipimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-60.svg";
import sheetuploadimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-38.svg";
import helpdeskimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-62.svg";

import grievancetype from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-63.svg";
import grievancelist from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-64.svg";
import ticketcategoryimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-65.svg";
import tickets from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-66.svg";

import masscoummunicationimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-67.svg";
import adminrightsimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-69.svg";
import geolocationimg from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-72.svg";
import stateimgs from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-73.svg";

import regionalimgs from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-74.svg";

import zoneimages from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-75.svg";
import OvertimeImage from "../../../Assets/AppComponent/SideBarImages/BlackImage/Asset 3.svg";
import MyonboardingBlackImage from "../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-120.svg";

import { subDays, startOfYear, format } from "date-fns";

///---white---img

///-------sidebar--------images---
import DashboardWhiteImg from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-76.svg";
import Dashboardoverviewwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-77.svg";
import Dashboardattendancewhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-78.svg";
import DashboardonboardOverviewwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-79.svg";

import validationswhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-80.svg";
import aadharvalidationwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-81.svg";
import panvalidationwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-82.svg";
import whatsappvalidationwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-83.svg";

import bankcardValidationswhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-84.svg";
import clientImagewhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-85.svg";
import designationimagewhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-86.svg";
import userImageswhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-86.svg";

import onboardimagewhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-87.svg";
import appriverequstimagewhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-88.svg";
import onboardingemployeeswhite from "../../../Assets/AppComponent/SideBarImages/UDS 89.svg";
import attendancefeildwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-90.svg";

import attendanceReportwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-87.svg";
import LeaveTypeimgwhiteimg from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-88.svg";
import LeaveRequestwhiteimg from "../../../Assets/AppComponent/SideBarImages/UDS 89.svg";
import premissionrequestImgwhiteimg from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-90.svg";

import ondutyImgwhitemg from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-88.svg";
import attendanceregularzationImgwhite from "../../../Assets/AppComponent/SideBarImages/UDS 89.svg";
import skillAssesmentwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-90.svg";
import criteriawhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-91.svg";

import assementsImgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-92.svg";
import exitflowwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-93.svg";
import noduefomrimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-94.svg";
import resignimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-95.svg";

import employeementimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-96.svg";
import reimbursementimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS 97.svg";
import blockimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-98.svg";
import sitetransferwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-99.svg";

import activeDeactivewhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-100.svg";

import appraisalimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-101.svg";
import payslipimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-102.svg";
import sheetuploadimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-80.svg";
import helpdeskimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-104.svg";

import grievancetypewhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-105.svg";
import grievancelistwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-106.svg";
import ticketcategoryimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-107.svg";
import ticketswhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-108.svg";

import masscoummunicationimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-109.svg";
import adminrightsimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-111.svg";
import geolocationimgwhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-114.svg";
import stateimgswhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-115.svg";

import regionalimgswhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-116.svg";

import zoneimageswhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-117.svg";
import OvertimeImagewhite from "../../../Assets/AppComponent/Overall_icons/Asset 4.svg";

import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-32.svg";
import WhiteImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image.svg";
import MyOnboardingTabWhite from "../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-121.svg";

import Customerblack from "../../../Assets/AppComponent/Overall_icons/hr-person 1.svg";
import Customerwhiteimg from "../../../Assets/AppComponent/SideBarImages/hr-person 1 (1).svg";

import DashboardTicket from "../../../Assets/AppComponent/Vector (35).svg";
import DashboardTicketWhite from "../../../Assets/AppComponent/Vector (25).svg";

import DashboardTicketWhiteHeader from "../../../Assets/AppComponent/Vector (28).svg";
import DepartmentTicket from "../../../Assets/AppComponent/Vector (26).svg";
import DepartmentTicketWhite from "../../../Assets/AppComponent/Vector (36).svg";
import DashboardWhite from "../../../Assets/AppComponent/Group 427320186.svg";

import CategoryinternlaTicket from "../../../Assets/AppComponent/Vector (27).svg";
import CategoryInternalTicketWhite from "../../../Assets/AppComponent/Vector (30).svg";
import InternalTickets from "../../../Assets/AppComponent/Vector (35).svg";

import DepartmentLone from "../../../Assets/AppComponent/Group 427320179.svg";
import DepartmentLonewhite from "../../../Assets/AppComponent/Group 427320184.svg";

import Departmenttable from "../../../Assets/AppComponent/Group 427320183.svg";
import Departmenttablewhite from "../../../Assets/AppComponent/Group 427320188.svg";

import createtickettable from "../../../Assets/AppComponent/Union (35).svg";
import createtickettablewhite from "../../../Assets/AppComponent/Union (36).svg";

import internalsupportimg from "../../../Assets/AppComponent/Group 427320182.svg";
import internalsupportwhite from "../../../Assets/AppComponent/Group 427320187.svg";

import SubassignTickets from "../../../Assets/AppComponent/Union (3).svg";
import SubassignTicketsWhite from "../../../Assets/AppComponent/Union (4).svg";

import UnregisterTickets from "../../../Assets/AppComponent/Union (5).svg";
import UnregisterTicketsWhite from "../../../Assets/AppComponent/unregisterimg.svg";

import Notificationlisted from "../../../Assets/AppComponent/ticketnotify.svg";
import NotificationlistedWhite from "../../../Assets/AppComponent/ticketnotification.svg";

const SideBar = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );

  var list2 = [];
  var list3 = [];
  var list4 = [];
  var list5 = [];

  const EnglishData = data;
  const HindiData = hindiDatas;
  const formatDateFilter = (date) => format(date, "yyyy-MM-dd");

  const lastWeekRange = [
    formatDateFilter(subDays(new Date(), 6)),
    formatDateFilter(new Date()),
  ];

  const StatusDisplay = useSelector(
    (state) => state.sidebardispatchCall.SideStatus,
  );
  const [Active, SetActive] = useState(false);
  const [check, setCheck] = useState(false);
  const stateToogle = useSelector((state) => state.SideBarActive.SidebarActive);
  const state = useSelector((state) => state);
  const [entered, setEntered] = useState(false);
  const [DropDown, setDropDown] = useState();
  const [Status, Setstatus] = useState(false);
  const UserData = useSelector((state) => state.users.UserData.data);

  // useEffect(() => {
  //   dispatch(getsidebarActions(Active))
  // }, [])

  const Swal = require("sweetalert2");

  const [sidebarMenu, setsidebarlis] = useState([]);
  var object = [];
  const [EmailID, setEmailID] = useState("");
  // console.log(UserData, "3974238UserData");
  useEffect(() => {
    if (UserData != undefined) {
      if (
        UserData.admin_access != undefined &&
        UserData.admin_access != "" &&
        UserData.admin_access != null &&
        UserData.admin_access != undefined
      ) {
        // console.log("yessdfsdf");

        UserData.admin_access.map((item) => {
          // console.log(item.toLowerCase(), "dfsdf");
          object.push(item.toLowerCase());
        });
        console.log(UserData.email, "927309UserData");
        setEmailID(UserData.email);

        setsidebarlis(object);
      }
    }
  }, [state.users.UserData.data]);

  useEffect(() => {
    if (UserData != undefined) {
      if (
        // sidebarMenu != undefined &&
        // sidebarMenu.length == 0  && !sidebarMenu.length > 0

        (UserData != undefined &&
          UserData != null &&
          UserData &&
          UserData != undefined &&
          UserData.admin_access != undefined &&
          UserData.admin_access != null &&
          UserData.admin_access != undefined &&
          UserData.admin_access.length < 0) ||
        UserData.admin_access.length == 0
      ) {
        // setInterval(() => {
        //   window.location.reload();
        //   localStorage.clear();
        //   window.location.href = "/";
        // }, 600);

        let timerInterval;
        Swal.fire({
          title: "Your are not an Authorized Person alert!",
          html: "It will close in <b></b> milliseconds.",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            container: "custom-swal-container",
          },
          didOpen: () => {
            Swal.showLoading();
            const timer = Swal.getPopup().querySelector("b");
            timerInterval = setInterval(() => {
              timer.textContent = `${Swal.getTimerLeft()}`;
              // setInterval(() => {
              //   window.location.reload();
              //   localStorage.clear();
              //   window.location.href = "/";
              // }, 600);
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            console.log("I was closed by the timer");
            navigate("/");
          }
        });
      }
    }
  }, [UserData]);

  const dispatch = useDispatch();
  const handleDialog = () => {
    if (stateDisplay) {
      dispatch(getsidebarActions(Active));
    }
  };

  const handleSecDailog = () => {
    if (stateDisplay) {
      dispatch(getsidebarActions(Active));
    }
  };
  const navigate = useNavigate();

  const handleClick = (link) => {
    navigate(link);
    dispatch(SetTHeNavigateList([link]));
  };

  const HandleActives = (e) => {
    dispatch(getSideBarfilesActions(e));
    dispatch(SetTHeNavigateList(e));
  };

  // const HandleDropDownActives = (e)=>{
  //   dispatch(getSideBarfilesActions(e));
  //   console.log(e ,"dropDown");

  // }
  const [Expand, setExpand] = useState();
  const [isActive, setIsActive] = useState(false);

  const [expand, setexpand] = useState();
  const sidebaractive = useDispatch();
  const RoleBased = useSelector((state) =>
    state.SideBarFiles.Role.toLowerCase(),
  );

  const SIDEBAR = [
    sidebarMenu != undefined &&
    sidebarMenu.includes("dashboard") && {
      id: 90,
      icon: (
        <>
          <img className="redImage" src={DashboardWhiteIma} />
          <img className="whiteImage" src={DashboardWhiteImg} />
        </>
      ),
      text: "Dashboard",
      subMenus: [
        state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
        state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
        state.SideBarFiles.UserEmailID != "arcolab@uds.in" &&
        !UserData?.is_client_attendance && {
          name: "Overview",
          link: "/",
          icon: (
            <>
              <img className="redImage" src={Dashboardoverview} />
              <img className="whiteImage" src={Dashboardoverviewwhite} />
            </>
          ),
          text: "Overview",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile === "Overview"
              ? " activesidemenu"
              : ""
            }`,
        },
        // {
        //   name: "Attendance Overview",
        //   link: "/attendances",
        //   icon: (
        //     <>
        //       <img className="redImage" src={Dashboardattendance} />
        //       <img className="whiteImage" src={Dashboardattendancewhite} />
        //     </>
        //   ),

        //   text: "Attendance Overview",
        //   class:
        //     "" +
        //     `${state.SideBarFiles.SideBarFile == "Attendance Overview"
        //       ? " activesidemenu"
        //       : ""
        //     }`,
        // },

        state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
        state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
        state.SideBarFiles.UserEmailID != "arcolab@uds.in" &&
        !UserData?.is_client_attendance && {
          name: "Onboard Overview",
          link: "/onboardDashboard",
          icon: (
            <>
              <img className="redImage" src={DashboardonboardOverview} />
              <img
                className="whiteImage"
                src={DashboardonboardOverviewwhite}
              />
            </>
          ),
          text: "Onboard Overview",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Onboard Overview"
              ? " activesidemenu"
              : ""
            }`,
        },
        state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
        state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
        state.SideBarFiles.UserEmailID != "arcolab@uds.in" &&
        !UserData?.is_client_attendance && {
          name: "Kyc Overview",
          link: "/advance_dashboard",
          icon: (
            <>
              <img className="redImage" src={DashboardonboardOverview} />
              <img
                className="whiteImage"
                src={DashboardonboardOverviewwhite}
              />
            </>
          ),
          text: "Kyc Overview",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Kyc Overview"
              ? " activesidemenu"
              : ""
            }`,
        },
        state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
        state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
        state.SideBarFiles.UserEmailID != "arcolab@uds.in" && {
          name: "Attendance Dashboard",
          link: "/advance_attendance",
          icon: (
            <>
              <img className="redImage" src={attendancefeild} />
              <img className="whiteImage" src={attendancefeildwhite} />
            </>
          ),
          text: "Attendance Dashboard",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Attendance Dashboard"
              ? " activesidemenu"
              : ""
            }`,
        },
        (state.SideBarFiles.UserEmailID == "hdfcsales@uds.in" ||
          state.SideBarFiles.UserEmailID == "sbilife@uds.in" ||
          state.SideBarFiles.UserEmailID == "arcolab@uds.in") && {
          name: "Attendance Dashboard ",
          link: "/advance_new_attendance",
          icon: (
            <>
              <img className="redImage" src={attendancefeild} />
              <img className="whiteImage" src={attendancefeildwhite} />
            </>
          ),
          text: "Attendance Dashboard ",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Attendance Dashboard "
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("validation") && {
      id: 95,
      icon: (
        <>
          <img className="redImage" src={validations} />
          <img className="whiteImage" src={validationswhite} />
        </>
      ),
      // icon: <TimelapseIcon style={{ padding: "12px", fontSize: "46px" }} />,
      text: "Validation Report",
      subMenus: [
        // {
        //   name: "Validations Overview",
        //   link: "/validate",
        //   icon: (
        //     <i
        //       class="fa-solid fa-coins"
        //       style={{
        //         padding: "13px 0px",
        //         fontSize: "19px",
        //         marginLeft: "23px",
        //       }}
        //     ></i>
        //   ),
        //   text: "Validations Overview",
        //   class:
        //     "" +
        //     `${
        //       state.SideBarFiles.SideBarFile == "Validations Overview"
        //         ? " activesidemenu"
        //         : ""
        //     }`,
        // },

        // report overview
        sidebarMenu != undefined &&
        sidebarMenu.includes("report overview") && {
          name: "Report Overview",
          link: "/validation",
          icon: (
            // <SickIcon style={{ padding: "10px", fontSize: "46px" }} />
            // <i
            //   class="fa-brands fa-square-whatsapp"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "26px",
            //   }}
            // ></i>
            // <img src={whatsappvalidation} />

            <>
              <img className="redImage" src={validations} />
              <img className="whiteImage" src={validationswhite} />
            </>
          ),
          text: "Report Overview",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Report Overview"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("aadhaar card report") && {
          name: "Aadhaar Card Report",
          link: "/aadharvalidate",
          icon: (
            <>
              <img className="redImage" src={aadharvalidation} />
              <img className="whiteImage" src={aadharvalidationwhite} />
            </>
          ),

          text: "Aadhaar Card Report",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Aadhaar Card Report"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("pan card report") && {
          name: "Pan Card Report",
          link: "/panvalidate",
          icon: (
            // <i
            //   class="fa-solid fa-id-card"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "26px",
            //   }}
            // ></i>
            <>
              <img className="redImage" src={panvalidation} />
              <img className="whiteImage" src={panvalidationwhite} />
            </>
          ),

          text: "Pan Card Report",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Pan Card Report"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("whatsapp report") && {
          name: "WhatsApp Report",
          link: "/whatsappvalidate",
          icon: (
            // <SickIcon style={{ padding: "10px", fontSize: "46px" }} />
            // <i
            //   class="fa-brands fa-square-whatsapp"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "26px",
            //   }}
            // ></i>
            // <img src={whatsappvalidation} />

            <>
              <img className="redImage" src={whatsappvalidation} />
              <img className="whiteImage" src={whatsappvalidationwhite} />
            </>
          ),
          text: "WhatsApp Report",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "WhatsApp Report"
              ? " activesidemenu"
              : ""
            }`,
        },
        sidebarMenu != undefined &&
        sidebarMenu.includes("bank penny drop report") && {
          name: "Bank Penny Drop Report",
          link: "/bankvalidate",
          icon: (
            // <SickIcon style={{ padding: "10px", fontSize: "46px" }} />
            // <i
            //   class="fa-solid fa-building-columns"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "26px",
            //   }}
            // ></i>
            // <img src={bankcardValidations} />

            <>
              <img className="redImage" src={bankcardValidations} />
              <img className="whiteImage" src={bankcardValidationswhite} />
            </>
          ),
          text: "Bank Penny Drop Report",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Bank Penny Drop Report"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    ((state.SideBarFiles.UserEmailID == "codoid@gmail.com" &&
      state.SideBarFiles.UserEmailID == "admin@uds.in") ||
      state.SideBarFiles.UserEmailID == "admin@gmail.com" ||
      EmailID == "porulraj.s@uds.in" ||
      state.SideBarFiles.UserEmailID == "adminit@uds.in") && {
      id: 18,
      icon: (
        <>
          <img className="redImage" src={DashboardWhiteIma} />
          <img className="whiteImage" src={DashboardWhiteImg} />
        </>
      ),
      text: "Master Dashboard",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Master Dashboard"
          ? " activesidemenu"
          : ""
        }`,
      link: "/master_dash",
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("client") && {
      id: 1,
      icon: (
        <>
          <img className="redImage" src={clientImage} />
          <img className="whiteImage" src={clientImagewhite} />
        </>
      ),
      text: "Client",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Client" ? " activesidemenu" : ""
        }`,
      link: "/client",
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("role") && {
      id: 4,
      icon: (
        <>
          <img className="redImage" src={designationimage} />
          <img className="whiteImage" src={designationimagewhite} />
        </>
      ),
      text: "Designation",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Designation"
          ? " activesidemenu"
          : ""
        }`,
      link: "/designation",
    },

    // employee actions

    sidebarMenu != undefined &&
    sidebarMenu.includes("employee actions") &&
    // (state.SideBarFiles.UserEmailID == "codoid@gmail.com" && state.SideBarFiles.UserEmailID == "admin@uds.in" || state.SideBarFiles.UserEmailID == "admin@gmail.com" || EmailID == "porulraj.s@uds.in") &&
    {
      id: 33,
      icon: (
        <>
          <img className="redImage" src={userImages} />
          <img className="whiteImage" src={userImageswhite} />
        </>
      ),
      text: "Employees",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Employees"
          ? " activesidemenu"
          : ""
        }`,
      link: "/employeeaction",
    },
    // Sony employee actions

    sidebarMenu != undefined &&
    sidebarMenu.includes("sony employees") &&
    // (state.SideBarFiles.UserEmailID == "codoid@gmail.com" && state.SideBarFiles.UserEmailID == "admin@uds.in" || state.SideBarFiles.UserEmailID == "admin@gmail.com" || EmailID == "porulraj.s@uds.in") &&
    {
      id: 33,
      icon: (
        <>
          <img className="redImage" src={userImages} />
          <img className="whiteImage" src={userImageswhite} />
        </>
      ),
      text: "Sony Employees",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Sony Employees"
          ? " activesidemenu"
          : ""
        }`,
      link: "/sonyemployeeaction",
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("users") && {
      id: 3,
      icon: (
        <>
          <img className="redImage" src={userImages} />
          <img className="whiteImage" src={userImageswhite} />
        </>
      ),

      text: "User",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "User" ? " activesidemenu" : ""
        }`,
      link: "/user",
    },

    // sidebarMenu != undefined &&
    //   sidebarMenu.includes("kyc verification" || "onboarding") &&

    sidebarMenu != undefined &&
    (sidebarMenu.includes("kyc verification") ||
      sidebarMenu.includes("onboarding")) && {
      // ||
      // sidebarMenu.includes("my onboarding list"))
      id: 69,
      icon: (
        <>
          <img className="redImage" src={onboardimage} />
          <img className="whiteImage" src={onboardimagewhite} />
        </>
      ),

      text: "Onboard",
      subMenus: [
        sidebarMenu != undefined &&
        sidebarMenu.includes("kyc verification") && {
          name: "Approve Request",
          // link: "/verifyrequest",
          // link: "/employeeVerifylist",
          link: "/approverequestemp",
          icon: (
            // <i
            //   class="fa-solid fa-users-line"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={appriverequstimage} />

            <>
              <img className="redImage" src={appriverequstimage} />
              <img className="whiteImage" src={appriverequstimagewhite} />
            </>
          ),
          text: "Approve Request",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Approve Request"
              ? " activesidemenu"
              : ""
            }`,
        },
        sidebarMenu != undefined &&
        sidebarMenu.includes("onboarding") && {
          // state.ClientBranchIDs.SUBROLE == 3 && {
          name: "Onboarding",
          link: "/fieldagent",
          icon: (
            // <i
            //   class="fa-solid fa-person-arrow-up-from-line"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={onboardingemployees} />

            <>
              <img className="redImage" src={onboardingemployees} />
              <img className="whiteImage" src={onboardingemployeeswhite} />
            </>
          ),

          text: "Onboarding",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Onboarding"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("onboarding") && {
          // state.ClientBranchIDs.SUBROLE == 3 && {
          name: "My Onboarding List",
          link: "/myonboarding",
          icon: (
            // <i
            //   class="fa-solid fa-person-arrow-up-from-line"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={onboardingemployees} />

            <>
              <img className="redImage" src={onboardingemployees} />
              <img className="whiteImage" src={onboardingemployeeswhite} />
            </>
          ),

          text: "My Onboarding List",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "My Onboarding List"
              ? " activesidemenu"
              : ""
            }`,
        },
        sidebarMenu != undefined &&
        sidebarMenu.includes("hr onboarding") && {
          // state.ClientBranchIDs.SUBROLE == 3 && {
          name: "HR Onboarding List",
          link: "/hrapprovallist",
          icon: (
            // <i
            //   class="fa-solid fa-person-arrow-up-from-line"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={onboardingemployees} />

            <>
              <img className="redImage" src={onboardingemployees} />
              <img className="whiteImage" src={onboardingemployeeswhite} />
            </>
          ),

          text: "HR Onboarding List",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "HR Onboarding List"
              ? " activesidemenu"
              : ""
            }`,
        },
        sidebarMenu != undefined &&
        sidebarMenu.includes("hrms connectivity") && {
          // state.ClientBranchIDs.SUBROLE == 3 && {
          name: "HRMS Connectivity",
          link: "/hrmsconnectivity",
          icon: (
            // <i
            //   class="fa-solid fa-person-arrow-up-from-line"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={onboardingemployees} />

            <>
              <img className="redImage" src={onboardingemployees} />
              <img className="whiteImage" src={onboardingemployeeswhite} />
            </>
          ),

          text: "HRMS Connectivity",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "HRMS Connectivity"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    sidebarMenu != undefined &&
    (sidebarMenu.includes("attendances") ||
      sidebarMenu.includes("leave permission") ||
      sidebarMenu.includes("shift permission") ||
      sidebarMenu.includes("attendance regularization") ||
      sidebarMenu.includes("overtime regularization") ||
      sidebarMenu.includes("attendance report")) && {
      id: 39,
      icon: (
        // <i
        //   class="fa-solid fa-clipboard-user"
        //   style={{ padding: "13px", fontSize: "17px" }}
        // ></i>
        // <img src={attendancefeild} />

        <>
          <img className="redImage" src={attendancefeild} />
          <img className="whiteImage" src={attendancefeildwhite} />
        </>
      ),

      text: "Attendance",
      subMenus: [
        sidebarMenu != undefined &&
        sidebarMenu.includes("attendance report") && {
          name: "Attendance Report",
          link: "/report",
          icon: (
            // <PlaceIcon
            // style={{
            // padding: "14px 0px",
            // fontSize: "45px",
            // marginLeft: "12px",
            // marginTop: "5px",
            // }}

            // />

            // <i
            //   // class="fa-solid fa-earth-americas"
            //   class="fa-solid fa-clipboard"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>

            <>
              <img className="redImage" src={attendanceReport} />
              <img className="whiteImage" src={attendanceReportwhite} />
            </>

            // attendanceReportwhite

            // <i class="fa-solid fa-chess-pawn"  style={{ padding: "13px", fontSize: "17px"  }}></i>
          ),
          text: "Attendance  Report",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Attendance  Report"
              ? " activesidemenu"
              : ""
            }`,
        },
        ((state.SideBarFiles.UserEmailID == "codoid@gmail.com" &&
          state.SideBarFiles.UserEmailID == "admin@uds.in") ||
          state.SideBarFiles.UserEmailID == "admin@gmail.com" ||
          EmailID == "porulraj.s@uds.in" ||
          state.SideBarFiles.UserEmailID == "adminit@uds.in") && {
          name: "Leave type",
          link: "/leavetype",
          icon: (
            // <SouthAmericaIcon
            // style={{
            // padding: "13px 0px",
            // fontSize: "45px",
            // marginLeft: "10px",
            // marginTop: "5px",
            // }}
            // />

            // <i
            //   class="fa-regular fa-rectangle-list"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     // marginLeft: "26px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={LeaveTypeimg} />

            <>
              <img className="redImage" src={LeaveTypeimg} />
              <img className="whiteImage" src={LeaveTypeimgwhiteimg} />
            </>
          ),

          text: "Leave type",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Leave type"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("leave permission") && {
          name: "Leave Request",
          link: "/leavepermission",
          icon: (
            // <SouthAmericaIcon
            // style={{
            // padding: "13px 0px",
            // fontSize: "45px",
            // marginLeft: "10px",
            // marginTop: "5px",
            // }}
            // />
            // <i
            //   class="fa-solid fa-person-through-window"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     // marginLeft: "26px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={LeaveRequest} />

            <>
              <img className="redImage" src={LeaveRequest} />
              <img className="whiteImage" src={LeaveRequestwhiteimg} />
            </>
          ),

          text: "Leave Request",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Leave Request"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("shift permission") && {
          name: "Permission  Request",
          link: "/Permission",
          icon: (
            // <SouthAmericaIcon
            // style={{
            // padding: "13px 0px",
            // fontSize: "45px",
            // marginLeft: "10px",
            // marginTop: "5px",
            // }}
            // />

            // <i
            //   class="fa-solid fa-hourglass-half"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     //  marginLeft: "26px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={premissionrequestImg} />

            <>
              <img className="redImage" src={premissionrequestImg} />
              <img
                className="whiteImage"
                src={premissionrequestImgwhiteimg}
              />
            </>
          ),

          text: "Permission Request",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Permission Request"
              ? " activesidemenu"
              : ""
            }`,
        },
        // {
        //   name: "On-Duty Request",
        //   link: "/Onduty",
        //   icon: (

        //     <>
        //       <img className="redImage" src={ondutyImg} />
        //       <img className="whiteImage" src={ondutyImgwhitemg} />
        //     </>
        //   ),

        //   text: "On-Duty Request",
        //   class:
        //     "" +
        //     `${
        //       state.SideBarFiles.SideBarFile == "On-Duty Request"
        //         ? " activesidemenu"
        //         : ""
        //     }`,
        // },
        sidebarMenu != undefined &&
        sidebarMenu.includes("attendance regularization") && {
          name: "Attendance Regularization",
          link: "/attendancerequest",
          icon: (
            // <SouthAmericaIcon
            // style={{
            // padding: "13px 0px",
            // fontSize: "45px",
            // marginLeft: "10px",
            // marginTop: "5px",
            // }}
            // />

            // <i
            //   class="fa-solid fa-business-time"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     /// marginLeft: "26px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={attendanceregularzationImg} />

            <>
              <img className="redImage" src={attendanceregularzationImg} />
              <img
                className="whiteImage"
                src={attendanceregularzationImgwhite}
              />
            </>
          ),

          text: "Attendance Regularization",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Attendance Regularization"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("overtime regularization") && {
          name: "Overtime Regularization",
          link: "/overtimerequest",
          icon: (
            <>
              <img className="redImage overtimeimg" src={OvertimeImage} />
              <img
                className="whiteImage overtimeimg"
                src={OvertimeImagewhite}
              />
            </>
          ),

          text: "Overtime Regularization",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Overtime Regularization"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("assements") && {
      id: 59,
      icon: (
        // <i
        //   class="fa-solid fa-chart-pie"
        //   style={{ padding: "13px", fontSize: "17px" }}
        // ></i>

        // <img src={skillAssesment} />

        <>
          <img className="redImage" src={skillAssesment} />
          <img className="whiteImage" src={skillAssesmentwhite} />
        </>
      ),
      text: " Skill Assessments",
      subMenus: [
        {
          name: "Criteria",
          link: "/performance",
          icon: (
            // <i
            //   class="fa-solid fa-chart-simple"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>

            // <img src={criteria} />

            <>
              <img className="redImage" src={criteria} />
              <img className="whiteImage" src={criteriawhite} />
            </>
          ),
          text: "Criteria",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Criteria"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "Performance Request",
          link: "/manpower",
          //  link:"/manpowerperform",====>gromming list out
          //  link:"/gromming",===>gromming marks ,assessmentrequest
          icon: (
            <>
              <img className="redImage" src={assementsImg} />
              <img className="whiteImage" src={assementsImgwhite} />
            </>
          ),

          text: "Assessments Request",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Assessments Request"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("exit flow") && {
      id: 69,
      icon: (
        // <i
        //   class="fa-solid fa-person-through-window"
        //   style={{ padding: "13px", fontSize: "17px" }}
        // ></i>

        // <img src={exitflow} />

        <>
          <img className="redImage" src={exitflow} />
          <img className="whiteImage" src={exitflowwhite} />
        </>
      ),
      text: "Exit Flow",
      subMenus: [
        {
          name: "Exit Clearance",
          link: "/exit-clearance",
          icon: (
            <>
              <img className="redImage" src={noduefomrimg} />
              <img className="whiteImage" src={noduefomrimgwhite} />
            </>
          ),
          text: "Exit Clearance",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Exit Clearance"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "Bulk Exit Initiate",
          link: "/exit-clearance/bulk-initiate",
          icon: (
            <>
              <img className="redImage" src={noduefomrimg} />
              <img className="whiteImage" src={noduefomrimgwhite} />
            </>
          ),
          text: "Bulk Exit Initiate",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Bulk Exit Initiate"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "No Due Form",
          link: "/exit",
          //  link:"/nodue",
          icon: (
            // <PlaceIcon
            // style={{
            // padding: "14px 0px",
            // fontSize: "45px",
            // marginLeft: "12px",
            // marginTop: "5px",
            // }}

            // />

            // <i
            //   // class="fa-solid fa-earth-americas"
            //   class="fa-regular fa-newspaper"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>

            // <img src={noduefomrimg} />

            <>
              <img className="redImage" src={noduefomrimg} />
              <img className="whiteImage" src={noduefomrimgwhite} />
            </>

            // <i class="fa-solid fa-chess-pawn"  style={{ padding: "13px", fontSize: "17px"  }}></i>
          ),
          text: "No Due Form",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "No Due Form"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "Resign",
          link: "/resign",
          icon: (
            // <SouthAmericaIcon
            // style={{
            // padding: "13px 0px",
            // fontSize: "45px",
            // marginLeft: "10px",
            // marginTop: "5px",
            // }}
            // />

            // <i
            //   class="fa-solid fa-person-walking-arrow-right"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>

            // <img src={resignimg} />

            <>
              <img className="redImage" src={resignimg} />
              <img className="whiteImage" src={resignimgwhite} />
            </>
          ),

          text: "Resign",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Resign"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    ///----Employeeement-----------
    sidebarMenu != undefined &&
    (sidebarMenu.includes("reimbursement") ||
      sidebarMenu.includes("pay slip") ||
      sidebarMenu.includes("active employee") ||
      sidebarMenu.includes("appraisal") ||
      sidebarMenu.includes("site transfer") |
      sidebarMenu.includes("black")) && {
      id: 69,
      icon: (
        <>
          <img className="redImage" src={employeementimg} />
          <img className="whiteImage" src={employeementimgwhite} />
        </>
      ),
      text: "Employment",
      subMenus: [
        sidebarMenu != undefined &&
        sidebarMenu.includes("reimbursement") && {
          name: "Reimbursement",
          link: "/reimbursement",
          icon: (
            // <i
            //   class="fa-solid fa-hand-holding-dollar"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={reimbursementimg} />

            <>
              <img className="redImage" src={reimbursementimg} />
              <img className="whiteImage" src={reimbursementimgwhite} />
            </>
          ),
          text: "Reimbursement",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Reimbursement"
              ? " activesidemenu"
              : ""
            }`,
        },
        sidebarMenu != undefined &&
        sidebarMenu.includes("black") && {
          name: "Employee Block  Request",
          link: "/blacklist",
          icon: (
            // <i
            //   class="fa-solid fa-ban"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={blockimg} />

            <>
              <img className="redImage" src={blockimg} />
              <img className="whiteImage" src={blockimgwhite} />
            </>
          ),
          text: "Employee Block  Request",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Employee Block  Request"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("site transfer") && {
          name: "Site Transfer",
          link: "/sitetransfer",
          icon: (
            // <i
            //   class="fa-brands fa-laravel"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={sitetransfer} />

            <>
              <img className="redImage" src={sitetransfer} />
              <img className="whiteImage" src={sitetransferwhite} />
            </>
          ),

          text: "Site Transfer",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Site Transfer"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("active employee") && {
          name: "Active and Deactive",
          link: "/activeEmployee",
          icon: (
            // <i
            //   class="fa-brands fa-creative-commons-by"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={activeDeactive} />

            <>
              <img className="redImage" src={activeDeactive} />
              <img className="whiteImage" src={activeDeactivewhite} />
            </>
          ),

          text: "Active and Deactive",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Active and Deactive"
              ? " activesidemenu"
              : ""
            }`,
        },

        // sidebarMenu != undefined &&
        //   sidebarMenu.includes("appraisal") && {
        //     name: "Appraisal",
        //     link: "/appraisal",
        //     icon: (
        //       // <i
        //       //   class="fa-solid fa-comments-dollar"
        //       //   style={{
        //       //     padding: "13px 0px",
        //       //     fontSize: "19px",
        //       //     marginLeft: "23px",
        //       //   }}
        //       // ></i>
        //       // <img src={appraisalimg} />

        //       <>
        //         <img className="redImage" src={appraisalimg} />
        //         <img className="whiteImage" src={appraisalimgwhite} />
        //       </>
        //     ),

        //     text: "Appraisal",
        //     class:
        //       "" +
        //       `${
        //         state.SideBarFiles.SideBarFile == "Appraisal"
        //           ? " activesidemenu"
        //           : ""
        //       }`,
        //   },

        sidebarMenu != undefined &&
        sidebarMenu.includes("pay slip") && {
          name: "Pay slip",
          link: "/payslip",
          icon: (
            // <i
            //   class="fa-regular fa-credit-card"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>

            // <img src={payslipimg} />

            <>
              <img className="redImage" src={payslipimg} />
              <img className="whiteImage" src={payslipimgwhite} />
            </>
          ),

          text: "Payslip",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Payslip"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    // sidebarMenu != undefined &&
    // sidebarMenu.includes("sheet upload") && {
    //   id: 15,
    //   icon: (
    //     // <DriveFolderUploadIcon
    //     //   style={{ padding: "12px", fontSize: "46px" }}
    //     // />

    //     // <img src={sheetuploadimg} />

    //     <>
    //       <img className="redImage" src={sheetuploadimg} />
    //       <img className="whiteImage" src={sheetuploadimgwhite} />
    //     </>
    //   ),
    //   text: "Sheet upload",
    //   class:
    //     "adminusernav" +
    //     `${state.SideBarFiles.SideBarFile == "Sheet upload"
    //       ? " activesidemenu"
    //       : ""
    //     }`,
    //   link: "/sheetupload",
    // },

    sidebarMenu != undefined &&
    (sidebarMenu.includes("help desk") ||
      sidebarMenu.includes("category")) && {
      id: 90,
      icon: (
        // <i
        //   class="fa-solid fa-handshake-angle"
        //   style={{ padding: "13px", fontSize: "17px" }}
        // ></i>
        // <img src={helpdeskimg} />

        <>
          <img className="redImage" src={helpdeskimg} />
          <img className="whiteImage" src={helpdeskimgwhite} />
        </>
      ),
      text: "Help Desk",
      subMenus: [
        {
          name: "Grievance Type",
          link: "/grievance",
          icon: (
            // <PlaceIcon
            // style={{
            // padding: "14px 0px",
            // fontSize: "45px",
            // marginLeft: "12px",
            // marginTop: "5px",
            // }}

            // />

            // <i
            //   // class="fa-solid fa-earth-americas"
            //   class="fa-brands fa-yelp"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={grievancetype} />

            <>
              <img className="redImage" src={grievancetype} />
              <img className="whiteImage" src={grievancetypewhite} />
            </>

            // <i class="fa-solid fa-chess-pawn"  style={{ padding: "13px", fontSize: "17px"  }}></i>
          ),
          text: "Grievance Type",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Grievance Type"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "Grievance List",
          link: "/grievancelist",
          icon: (
            // <SouthAmericaIcon
            // style={{
            // padding: "13px 0px",
            // fontSize: "45px",
            // marginLeft: "10px",
            // marginTop: "5px",
            // }}
            // />

            // <i
            //   class="fa-solid fa-person-shelter"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>

            // <img src={grievancelist} />

            <>
              <img className="redImage" src={grievancelist} />
              <img className="whiteImage" src={grievancelistwhite} />
            </>
          ),

          text: "Grievance List",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Grievance List"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "Tickets",
          link: "/ticketcategory",
          icon: (
            // <i
            //   class="fa-solid fa-chart-simple"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>

            // <img src={ticketcategoryimg} />

            <>
              <img className="redImage" src={ticketcategoryimg} />
              <img className="whiteImage" src={ticketcategoryimgwhite} />
            </>
          ),
          text: "Ticket Category",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Ticket Category"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "Tickets",
          link: "/tickets",
          icon: (
            // <i
            //   class="fa-solid fa-person-circle-check"
            //   style={{
            //     padding: "13px 0px",
            //     fontSize: "19px",
            //     marginLeft: "23px",
            //   }}
            // ></i>
            // <img src={tickets} />

            <>
              <img className="redImage" src={tickets} />
              <img className="whiteImage" src={ticketswhite} />
            </>
          ),

          text: "Tickets",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Tickets"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "My Tickets",
          link: "/mytickets",
          icon: (
            <>
              <img className="redImage" src={tickets} />
              <img className="whiteImage" src={ticketswhite} />
            </>
          ),

          text: "My Tickets",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "My Tickets"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },
    sidebarMenu != undefined &&
    sidebarMenu.includes("notificationscreen") && {
      id: 67,
      icon: (
        <>
          <img
            className="redImage ticketcustomerimg"
            src={Notificationlisted}
          />
          <img
            className="whiteImage ticketcustomerimg"
            src={NotificationlistedWhite}
          />
        </>
      ),
      text: "Notification",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Notification"
          ? " activesidemenu"
          : ""
        }`,
      link: "#",
      // link: dispatch(gettheSideBarNotificationState(!state.SideBarFiles.SideBarNotification))
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("ticketing system") && {
      id: 94,
      icon: (
        <>
          <img className="redImage ticketcustomerimg" src={Customerblack} />
          <img
            className="whiteImage ticketcustomerimg"
            src={Customerwhiteimg}
          />
        </>
      ),
      text: "Customer Support",
      subMenus: [
        (state.SideBarFiles.UserEmailID == "admin@gmail.com" ||
          state.SideBarFiles.UserEmailID == "adminit@uds.in") && {
          name: "Dashboard     ",
          link: "/customer_support_dashboard",
          icon: (
            <>
              <img className="redImage" src={DashboardWhiteIma} />
              <img className="whiteImage" src={DashboardWhiteImg} />
            </>
          ),

          text: "Dashboard     ",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Dashboard     "
              ? " activesidemenu"
              : ""
            }`,
        },

        state.SideBarFiles.UserEmailID != "admin@gmail.com" &&
        state.SideBarFiles.UserEmailID != "adminit@uds.in" && {
          name: "Dashboard",
          link: "/ticketdashboard",
          icon: (
            <>
              <img className="redImage" src={DashboardWhiteIma} />
              <img className="whiteImage" src={DashboardWhiteImg} />
            </>
          ),

          text: "Dashboard ",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Dashboard "
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "Tickets",
          link: "/ticketlist",
          icon: (
            <>
              <img className="redImage" src={tickets} />
              <img className="whiteImage" src={ticketswhite} />
            </>
          ),

          text: "Tickets",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Tickets"
              ? " activesidemenu"
              : ""
            }`,
        },

        {
          name: "Sub Assigned",
          link: "/sub_ticker",
          icon: (
            <>
              <img
                className="redImage ticketcustomerimg"
                src={SubassignTickets}
              />
              <img
                className="whiteImage ticketcustomerimg"
                src={SubassignTicketsWhite}
              />
            </>
          ),

          text: "Sub Assigned",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Sub Assigned"
              ? " activesidemenu"
              : ""
            }`,
        },

        {
          name: "Unregister",
          link: "/unregisterticket",
          icon: (
            <>
              <img
                className="redImage ticketcustomerimg"
                src={UnregisterTickets}
              />
              <img
                className="whiteImage ticketcustomerimg"
                src={UnregisterTicketsWhite}
              />
            </>
          ),

          text: "Unregistered",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Unregistered"
              ? " activesidemenu"
              : ""
            }`,
        },

        sidebarMenu != undefined &&
        sidebarMenu.includes("ticket category") && {
          name: "Tickets",
          link: "/ticket_category",
          icon: (
            <>
              <img className="redImage" src={ticketcategoryimg} />
              <img className="whiteImage" src={ticketcategoryimgwhite} />
            </>
          ),
          text: "Ticket Category",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Ticket Category"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    // / Internal Support  , Internal Master , Ticket List , My Tickets
    sidebarMenu != undefined &&
    sidebarMenu.includes("internal support") && {
      id: 99,
      icon: (
        <>
          <img
            className="redImage ticketcustomerimg"
            src={DashboardTicketWhiteHeader}
          />
          <img
            className="whiteImage ticketcustomerimg"
            src={DashboardWhite}
          />
        </>
      ),
      text: "Internal Support",
      subMenus: [
        // {
        //   name: "Ticket",
        //   link: "/internalTicket",
        //   icon: (

        //     <>
        //       <img className="redImage ticketcustomerimg" src={InternalTickets} />
        //       <img className="whiteImage ticketcustomerimg" src={InternalTickets} />
        //     </>
        //   ),
        //   text: "Tickets   ",
        //   class:
        //     "" +
        //     `${state.SideBarFiles.SideBarFile == "Tickets    "
        //       ? " activesidemenu"
        //       : ""
        //     }`,
        // },

        (state.SideBarFiles.UserEmailID == "admin@gmail.com" ||
          state.SideBarFiles.UserEmailID == "adminit@uds.in") && {
          name: "Dashboard     ",
          link: "/internal_support_dashboard",
          icon: (
            <>
              <img
                className="redImage ticketcustomerimg"
                src={DepartmentLone}
              />
              <img
                className="whiteImage ticketcustomerimg"
                src={DepartmentLonewhite}
              />
            </>
          ),
          text: "Dashboard     ",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Dashboard     "
              ? " activesidemenu"
              : ""
            }`,
        },
        // sidebarMenu != undefined &&
        // (sidebarMenu.includes("ticket list")) &&
        state.SideBarFiles.UserEmailID != "admin@gmail.com" &&
        state.SideBarFiles.UserEmailID != "adminit@uds.in" && {
          name: "Tickets",
          link: "/internal_Dashboard",
          icon: (
            <>
              <img
                className="redImage ticketcustomerimg"
                src={DepartmentLone}
              />
              <img
                className="whiteImage ticketcustomerimg"
                src={DepartmentLonewhite}
              />
            </>
          ),
          text: "Dashboard     ",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Dashboard     "
              ? " activesidemenu"
              : ""
            }`,
        },
        // sidebarMenu != undefined &&
        // (sidebarMenu.includes("my tickets")) &&

        // sidebarMenu != undefined &&
        // (sidebarMenu.includes("ticket list")) &&
        {
          name: "Tickets",
          link: "/internalTicketuserlist",
          icon: (
            <>
              <img
                className="redImage ticketcustomerimg"
                src={Departmenttable}
              />
              <img
                className="whiteImage ticketcustomerimg"
                src={Departmenttablewhite}
              />
            </>
          ),
          text: "Assigned Tickets",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Assigned Tickets"
              ? " activesidemenu"
              : ""
            }`,
        },

        {
          name: "Dashboard",
          link: "/internaldashboard",
          icon: (
            <>
              <img
                className="redImage ticketcustomerimg"
                src={createtickettable}
              />
              <img
                className="whiteImage ticketcustomerimg"
                src={createtickettablewhite}
              />
            </>
          ),

          text: "Created Tickets  ",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Created Tickets  "
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("internal master") && {
      id: 94,
      icon: (
        <>
          <img
            className="redImage ticketcustomerimg"
            src={internalsupportimg}
          />
          <img
            className="whiteImage ticketcustomerimg"
            src={internalsupportwhite}
          />
        </>
      ),
      text: "Internal Master",
      subMenus: [
        // sidebarMenu != undefined &&
        // (sidebarMenu.includes("ticket category")) &&
        {
          name: "Tickets",
          link: "/udscategory",
          icon: (
            <>
              <img
                className="redImage ticketcustomerimg"
                src={CategoryinternlaTicket}
              />
              <img
                className="whiteImage ticketcustomerimg"
                src={CategoryInternalTicketWhite}
              />
            </>
          ),
          text: "Category  ",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Category  "
              ? " activesidemenu"
              : ""
            }`,
        },

        // sidebarMenu != undefined &&
        // (sidebarMenu.includes("department")) &&

        {
          name: "Department",
          link: "/department",
          icon: (
            <>
              <img
                className="redImage ticketcustomerimg"
                src={DepartmentTicket}
              />
              <img
                className="whiteImage ticketcustomerimg"
                src={DepartmentTicketWhite}
              />
            </>
          ),

          text: "Department ",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Department "
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("sheet upload") && {
      id: 15,
      icon: (
        <>
          <img className="redImage" src={sheetuploadimg} />
          <img className="whiteImage" src={sheetuploadimgwhite} />
        </>
      ),
      text: "Sheet upload",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Sheet upload"
          ? " activesidemenu"
          : ""
        }`,
      link: "/sheetupload",
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("notification") && {
      id: 15,
      icon: (
        <>
          <img className="redImage" src={masscoummunicationimg} />
          <img className="whiteImage" src={masscoummunicationimgwhite} />
        </>
      ),
      text: "Mass Communication",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Mass Communication"
          ? " activesidemenu"
          : ""
        }`,
      link: "/communication",
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("admin user list") && {
      id: 4,
      icon: (
        <>
          <img className="redImage" src={adminrightsimg} />
          <img className="whiteImage" src={adminrightsimgwhite} />
        </>
      ),

      text: "Admin User Rights List",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Admin User Rights List"
          ? " activesidemenu"
          : ""
        }`,
      // link: "/employeeVerify",
      link: "/adminuserlist",
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("report") && {
      // {
      id: 25,
      // icon: <ReportIcon style={{ padding: "12px", fontSize: "46px" }} />,
      icon: (
        <>
          <img className="redImage" src={validations} />
          <img className="whiteImage" src={validationswhite} />
        </>
      ),
      text: "Report",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Report" ? " activesidemenu" : ""
        }`,
      link: "/reportsheet",
    },

    sidebarMenu != undefined &&
    sidebarMenu.includes("geo location") && {
      id: 9,
      icon: (
        <>
          <img className="redImage" src={geolocationimg} />
          <img className="whiteImage" src={geolocationimgwhite} />
        </>
      ),
      text: "Geo Location",
      subMenus: [
        {
          name: "Attendance Location",
          link: "/attendancelocation",
          icon: (
            <>
              <img className="redImage" src={attendancefeild} />
              <img className="whiteImage" src={attendancefeildwhite} />
            </>
          ),

          text: "Attendance Location",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Attendance Location"
              ? " activesidemenu"
              : ""
            }`,
        },

        {
          name: "State",
          link: "/state",
          icon: (
            <>
              <img className="redImage" src={stateimgs} />
              <img className="whiteImage" src={stateimgswhite} />
            </>
          ),
          text: "State",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "State"
              ? " activesidemenu"
              : ""
            }`,
        },
        {
          name: "Region",
          link: "/region",
          icon: (
            <>
              <img className="redImage" src={regionalimgs} />
              <img className="whiteImage" src={regionalimgswhite} />
            </>
          ),

          text: "Region",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Region"
              ? " activesidemenu"
              : ""
            }`,
        },

        {
          name: "Zone",
          link: "/zone",
          icon: (
            <>
              <img className="redImage" src={zoneimages} />
              <img className="whiteImage" src={zoneimageswhite} />
            </>
          ),
          text: "Zone",
          class:
            "" +
            `${state.SideBarFiles.SideBarFile == "Zone"
              ? " activesidemenu"
              : ""
            }`,
        },
      ],
    },
    sidebarMenu != undefined &&
    sidebarMenu.includes("bulkupload data") && {
      // {
      id: 23,
      // icon: <ReportIcon style={{ padding: "12px", fontSize: "46px" }} />,
      icon: (
        <>
          <img className="redImage" src={validations} />
          <img className="whiteImage" src={validationswhite} />
        </>
      ),
      text: "Bulkupload Data",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Bulkupload Data" ? " activesidemenu" : ""}`,
      link: "/sheetbulkupload",
    },
    sidebarMenu != undefined &&
    sidebarMenu.includes("denave bulkupload") && {
      // {
      id: 24,
      // icon: <ReportIcon style={{ padding: "12px", fontSize: "46px" }} />,
      icon: (
        <>
          <img className="redImage" src={validations} />
          <img className="whiteImage" src={validationswhite} />
        </>
      ),
      text: "Denave Bulkupload",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Denave Bulkupload" ? " activesidemenu" : ""}`,
      link: "/denavebulkupload",
    },
    sidebarMenu != undefined &&
    sidebarMenu.includes("sony bulkupload") && {
      // {
      id: 24,
      // icon: <ReportIcon style={{ padding: "12px", fontSize: "46px" }} />,
      icon: (
        <>
          <img className="redImage" src={validations} />
          <img className="whiteImage" src={validationswhite} />
        </>
      ),
      text: "Sony Bulkupload",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Sony Bulkupload" ? " activesidemenu" : ""}`,
      link: "/sonybulkupload",
    },
    sidebarMenu != undefined &&
    sidebarMenu.includes("smart connect") && {
      // {
      id: 24,
      // icon: <ReportIcon style={{ padding: "12px", fontSize: "46px" }} />,
      icon: (
        <>
          <img className="redImage" src={validations} />
          <img className="whiteImage" src={validationswhite} />
        </>
      ),
      text: "Smart Connect",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "Smart Connect" ? " activesidemenu" : ""}`,
      link: "/smartconnectupload",
    },
    sidebarMenu != undefined &&
    sidebarMenu.includes("id card") && {
      id: 100,
      icon: (
        <>
          <img className="redImage" src={onboardingemployees} />
          <img className="whiteImage" src={onboardingemployeeswhite} />
        </>
      ),
      text: "ID Card",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "ID Card" ? " activesidemenu" : ""}`,
      link: "/idcard",
    },
  ];

  const expandfunc = (e, index) => {
    // console.log(index, expand, "logggg");
    if (index == expand) {
      setexpand(null);
    } else if (index != expand) {
      setexpand(index);
      //  dispatch(getsidebarActions(isActive));
    }
  };

  // console.log(SIDEBAR, "SIDEBAR");

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  const [range, setrange] = useState([gt, it]);

  const sidebarhandleclick = (e) => {
    if (e == "Approve Request") {
      dispatch(setDropDownRenders("")); // display all the employees
      dispatch(getSingleEmployeeActions(""));
      dispatch(setTheApproveRequeststate(2));
    }
    if (e == "Onboarding") {
      dispatch(setaRoleChnage(2));
      dispatch(setTheRoleRemoveFilters(2));
      dispatch(setTheApproveRequeststate(4));
    } else {
      dispatch(setaRoleChnage(1));
      dispatch(setTheRoleRemoveFilters(1));
    }
    dispatch(getSideBarfilesActions(e));
    // if (stateDisplay) {
    // dispatch(getsidebarActions(isAcive));
    // }

    if (e == "Approve Request") {
      dispatch(setTheFROMDATELIST(range[0]));
      dispatch(setTheTODATELISTINDASH(range[1]));

      dispatch(SetDashboards("1"));
    }
    if (e === "Overview") {
      dispatch(setTheApproveRequeststate(6));
    }
    if (e === "Onboard Overview") {
      dispatch(setTheApproveRequeststate(7));
    }

    if (e == "My Tickets  ") {
      dispatch(settheTicketraiseroutes(0));
    }

    if (e == "Notification") {
      dispatch(
        gettheSideBarNotificationState(!state.SideBarFiles.SideBarNotification),
      );
    } else {
      dispatch(gettheSideBarNotificationState(false));
    }
    if (e == "Tickets") {
      // dispatch((settheTicketraiseroutes(1)))
      dispatch(setTheTicketingsystemStatusState({ value: "0", label: "Open" }));
      dispatch(setTheTicketingsystemtRange1(lastWeekRange[0]));
      dispatch(setTheTicketingsystemRange2(lastWeekRange[1]));
    }
    if (e == "Sub Assigned") {
      dispatch(
        settheTicketingSUbOptionValuesListed({ value: "0", label: "Open" }),
      );
    }
    if (e == "Assigned Tickets") {
      dispatch(settheInternal_Statuss({ value: "0", label: "Open" }));
      dispatch(gettheinternalUsersTicketingRangesone(lastWeekRange[0]));
      dispatch(gettheinternalUsersTicketingRangesTwo(lastWeekRange[1]));
    }
  };

  const [Hoverd, setHovered] = useState(false);
  // console.log(state.SideBarFiles.SideBarFile, "SideBarFile");

  ///---expanded if for the dashboard ,
  useEffect(() => {
    if (
      state.SideBarFiles.SideBarFile == "Dashboard" ||
      state.SideBarFiles.SideBarFile == "Overview" ||
      // state.SideBarFiles.SideBarFile == "Attendance Overview" ||
      state.SideBarFiles.SideBarFile == "Onboard Overview" ||
      state.SideBarFiles.SideBarFile == "Attendance Dashboard" ||
      state.SideBarFiles.SideBarFile == "Kyc Overview" ||
      state.SideBarFiles.SideBarFile == "Attendance Dashboard "
    ) {
      setexpand(false);
      // console.log("udfiudiufy", "skweuie");
    }
  }, [state.SideBarFiles.SideBarFile]);

  const hoverstate = (e, file) => {
    if (stateDisplay) {
      // console.log(e);
      // $(".sidebarclose").css(
      // "width",
      // "240px !important",
      // "border",
      // "3px solid red  "
      // );
      setHovered(true);
      // $(".sidebarclose").css("width", "450px !important");
      // $(".linkTextclosed").css("display", "block ");
      // $(".arrow").css("display", "block");
      // $(".linkText").css("display", "block !important");

      // SIDEBAR[3].subMenus.map((item) => {
      //console.log(SIDEBAR[2].id, "adafszlk");
      // if (state.SideBarFiles.SideBarFile == item.name) {
      //  console.log(state.SideBarFiles.SideBarFile, item.name, "testings");
      // setexpand(SIDEBAR[2].id);
      // expandfunc(3, 3);
      // } else {
      // setExpand(null);
      // }
      // });

      //---Needed--------------------
      // SIDEBAR != undefined && SIDEBAR != null  && SIDEBAR.length > 4 &&   SIDEBAR[4].subMenus.map((item) => {
      //   //  console.log(item.name, " asfdsfcxz", SIDEBAR[4].id);
      //    console.log(item ,"itemsdsa");
      //   if (state.SideBarFiles.SideBarFile == item.name) {
      //     //  console.log(state.SideBarFiles.SideBarFile, item.name, "Managesment");
      //     // setexpand(SIDEBAR[3].id);
      //     expandfunc(4, 4);
      //   } else {
      //     setExpand(null);
      //   }
      // });
    }
    // try {
    // console.log(SIDEBAR, "SideBarsLists", file);
    // SIDEBAR[9] != undefined &&
    // SIDEBAR[9] != "" &&
    // SIDEBAR[9] != false &&
    // SIDEBAR[9].subMenus.map((e) => {
    // list2.push(e.text);
    // });
    // console.log(list2, "List2");
    // SIDEBAR[5] != undefined &&
    // SIDEBAR[5] != "" &&
    // SIDEBAR[5].subMenus.map((e) => {
    // list3.push(e.text);
    // });
    // SIDEBAR[13] != undefined &&
    // SIDEBAR[13] != "" &&
    // SIDEBAR[13].subMenus.map((e) => {
    // list4.push(e.text);
    // });
    // SIDEBAR[15] != undefined &&
    // SIDEBAR[15] != "" &&
    // SIDEBAR[15].subMenus.map((e) => {
    // list5.push(e.text);
    // });

    // } catch (err) {
    //   console.log(err, "hover");
    // }
    // if (list2.includes(state.SideBarFiles.SideBarFile)) {
    //   setexpand(9);
    // } else if (list3.includes(state.SideBarFiles.SideBarFile)) {
    //   setexpand(5);
    // } else if (list4.includes(state.SideBarFiles.SideBarFile)) {
    //   setexpand(13);
    // } else if (list5.includes(state.SideBarFiles.SideBarFile)) {
    //   setexpand(15);
    // }
  };

  const hoverleave = (e) => {
    if (stateDisplay) {
      // console.log(e);
      // $(".sidebarclose").css("width", "65px !important");
      // $(".sidebarclose").css("width", "40px  !important");
      // $(".linkTextclosed").css("display", "none !important");
      // setexpand(false);
      // $(".arrow").css("display", "none");
      setHovered(false);

      // try {
      // console.log(SIDEBAR);
      // SIDEBAR[9] != undefined &&
      //   SIDEBAR[9] != "" &&
      //   SIDEBAR[9] != false &&
      //   SIDEBAR[9].subMenus.map((e) => {
      //     list2.push(e.text);
      //   });
      // SIDEBAR[5] != undefined &&
      //   SIDEBAR[5] != "" &&
      //   SIDEBAR[5].subMenus.map((e) => {
      //     list3.push(e.text);
      //   });
      // SIDEBAR[13] != undefined &&
      //   SIDEBAR[13] != "" &&
      //   SIDEBAR[13].subMenus.map((e) => {
      //     list4.push(e.text);
      //   });
      // SIDEBAR[15] != undefined &&
      //   SIDEBAR[15] != "" &&
      //   SIDEBAR[15].subMenus.map((e) => {
      //     list5.push(e.text);
      //   });
      // } catch (err) {
      //   console.log(err, "hover");
      // }
      // if (list2.includes(state.SideBarFiles.SideBarFile)) {
      //   setexpand(9);
      // } else if (list3.includes(state.SideBarFiles.SideBarFile)) {
      //   setexpand(5);
      // } else if (list4.includes(state.SideBarFiles.SideBarFile)) {
      //   setexpand(13);
      // } else if (list5.includes(state.SideBarFiles.SideBarFile)) {
      //   setexpand(15);
      // }
    }
  };
  // console.log(Hoverd, "83748374Hoverd", Hoverd ? "handle " : "NotHovered");
  return (
    <>
      <div
        className={stateDisplay || Hoverd ? "sidebarclose" : "sidebar"}
        // className={stateDisplay  ? "sidebarclose" : "sidebar"}
        id="sidebar"
        onMouseEnter={(e) => hoverstate(e, state.SideBarFiles.SideBarFile)}
        onMouseLeave={(e) => hoverleave(e)}
      >
        <div className={` NormalSide ${Hoverd ? "handle " : "NotHovered"}`}>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul className="sidebar_content">
                {SIDEBAR.length > 1 &&
                  SIDEBAR != undefined &&
                  SIDEBAR != null &&
                  SIDEBAR.map((item, index) => {
                    if (item.icon) {
                      return (
                        <>
                          <NavLink
                            // to={item.text == "Notification" ?
                            // dispatch(gettheSideBarNotificationState(!state.SideBarFiles.SideBarNotification)) :item.link}
                            // to={item.link}
                            to={item.text == "Notification" ? "#" : item.link} // Prevent navigation for "Notification"
                            style={{ textDecoration: "none" }}
                            onClick={() => {
                              if (item.text === "Notification") {
                                dispatch(
                                  gettheSideBarNotificationState(
                                    !state.SideBarFiles.SideBarNotification,
                                  ),
                                );
                              }
                            }}
                          >
                            <li
                              key={item.id}
                              className={`sideitem row  ${item.class}`}
                              href={item.link}
                              onClick={(e) => {
                                sidebarhandleclick(item.text);
                                if (item.subMenus) {
                                  expandfunc(e, index);
                                }
                              }}
                            >
                              <div href={item.link} className="col-2">
                                {item.icon}
                              </div>
                              <div
                                className={
                                  stateDisplay
                                    ? "linkText col-6"
                                    : "linkTextclosed col-6"
                                }
                                style={{
                                  display: stateDisplay ? "none" : "block",
                                  color: "#000",
                                }}
                              >
                                <NavLink
                                  //  className="nav-link"
                                  to={item.link}
                                  className={
                                    // "nav-link"
                                    ` nav-link ${item.subMenus && expand == index
                                      ? "expandeColor"
                                      : "notExpandedColor"
                                    }`
                                  }
                                >
                                  {item.text}
                                </NavLink>
                              </div>
                              {item.subMenus ? (
                                <>
                                  <div
                                    className="col-4 RightSideImage"
                                    onClick={(e) => {
                                      expandfunc(e, index);
                                    }}
                                  >
                                    <img
                                      src={BackImage}
                                      class={`CaretRightImgs BlackImgs ${expand == index
                                        ? " arrowexpand"
                                        : "arrownotexpand"
                                        } 
`}
                                      // ${Hoverd ? "notnow" : stateDisplay ? "displaing" : "releaseimg"}

                                      style={
                                        {
                                          // display: stateDisplay ? "none" : "block",
                                          // marginLeft: "30px",
                                          // fontSize:"16px"
                                        }
                                      }
                                    />
                                    <img
                                      src={WhiteImage}
                                      class={`CaretRightImgs  WhiteIconsImage${expand == index
                                        ? " arrowexpand"
                                        : "arrownotexpand"
                                        } 
                                      `}
                                      // ${Hoverd ? "notnow" : stateDisplay ? "displaing" : "releaseimg"}
                                      style={
                                        {
                                          // display: stateDisplay ? "none" : "block",
                                          // marginLeft: "30px",
                                          // fontSize:"16px"
                                        }
                                      }
                                    />
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </li>
                          </NavLink>
                          <ul
                            className={`sub-menu ${index}
                            
                            ${expand == index ? " activeside" : ""} 
                            
                            `}
                          >
                            {item.subMenus != undefined &&
                              item.subMenus?.map((ele) => {
                                //   console.log(ele, "segdvxc");
                                if (ele.link) {
                                  return (
                                    <NavLink
                                      to={ele.link}
                                      style={{ textDecoration: "none" }}
                                    >
                                      <li
                                        key={ele.id}
                                        className={`sideitem row ${ele.class}`}
                                        href={ele.link}
                                        onClick={(e) =>
                                          sidebarhandleclick(ele.text)
                                        }
                                      >
                                        <div href={ele.link} className="col-2">
                                          {ele.icon}
                                        </div>
                                        <span
                                          className={`SubitemWORDS  ${stateDisplay
                                            ? "linkText col-6"
                                            : "linkTextclosed col-6"
                                            }`}
                                          style={{
                                            display: stateDisplay
                                              ? "none"
                                              : "block",
                                          }}
                                        >
                                          <NavLink
                                            className="nav-link SubNavs"
                                            to={ele.link}
                                            style={{ textDecoration: "none" }}
                                          >
                                            {ele.text}
                                          </NavLink>
                                        </span>
                                      </li>
                                    </NavLink>
                                  );
                                }
                              })}
                          </ul>
                        </>
                      );
                    }
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SideBar;
